export default {
    testingMode: false,
};



// WEBPACK FOOTER //
// ./src/feature-config.ts